import classes from "./navigation-item.module.css";

export type NavigationItemProps = {
	label: string;
	url: string;
};

export const NavigationItem = ({ label, url }: NavigationItemProps) => (
	<a href={url} className={classes.item}>
		{label}
	</a>
);
